<template>
<section>
  <el-popover
    v-model="popVisible.RESERVE"
    @hide="handlePopHide('RESERVE', 'showReserveTextArea', 'reserveComments')"
  >
    <section v-if="reserveComments.length === 1 && reserveComments[0].showTextArea" class="comment-wrapper">
      <span class="error-msg">{{errorMsg.RESERVE}}</span>
      <el-input
        v-model="modelComments.RESERVE"
        type="textarea"
        :autosize="{minRows: 5}"
        style="width:100%;"
      />
      <el-button
        type="primary"
        size="mini"
        class="comment-btn"
        @click="handleSetCustomComment('RESERVE')"
      >确定</el-button>
    </section>
    <ul v-else class="comment-wrapper comment-list">
      <li
        v-for="(comment, index) in reserveComments"
        :key="index"
        :class="{active:showReserveTextArea ? index === (reserveComments.length - 1) : model.comment === comment.value}"
        class="comment-item"
        @click="handleSetComment(comment, 'RESERVE', 'showReserveTextArea')"
      >{{comment.id}}</li>
      <li
        v-if="showReserveTextArea"
        style="margin-top:.5em;"
        class="comment-wrapper"
      >
        <span class="error-msg">{{errorMsg.RESERVE}}</span>
        <el-input
          v-model="modelComments.RESERVE"
          type="textarea"
          :autosize="{minRows: 5}"
          style="width:100%;"
        />
        <el-button
          type="primary"
          size="mini"
          class="comment-btn"
          @click="handleSetCustomComment('RESERVE')"
        >确定</el-button>
      </li>
    </ul>
    <!-- :type="model.operatorType === 'RESERVE' ? 'success' : ''" -->
    <!-- :icon="model.operatorType === 'RESERVE' ? 'el-icon-circle-check' : ''" -->
    <el-button
      slot="reference"
      :disabled="disabled"
      type="success"
      icon="el-icon-circle-check"
      class="btn"
      size="mini"
    >保留</el-button>
  </el-popover>

  <el-popover
    v-model="popVisible.DELETE"
    @hide="handlePopHide('DELETE', 'showDeleteTextArea', 'deleteComments')"
  >
    <ul class="comment-wrapper comment-list">
      <li
        v-for="(comment, index) in deleteComments"
        :key="index"
        :class="{active:showDeleteTextArea ? index === (deleteComments.length - 1) : model.comment === comment.value}"
        class="comment-item"
        @click="handleSetComment(comment, 'DELETE', 'showDeleteTextArea')"
      >{{comment.id}}</li>
      <li
        v-if="showDeleteTextArea"
        style="margin-top:.5em;"
        class="comment-wrapper"
      >
        <span class="error-msg">{{errorMsg.DELETE}}</span>
        <el-input
          v-model="modelComments.DELETE"
          type="textarea"
          :autosize="{minRows: 5}"
          style="width:100%;"
        />
        <el-button
          type="primary"
          size="mini"
          class="comment-btn"
          @click="handleSetCustomComment('DELETE')"
        >确定</el-button>
      </li>
    </ul>
    <!-- :type="model.operatorType === 'DELETE' ? 'danger' : ''" -->
    <!-- :icon="model.operatorType === 'DELETE' ? 'el-icon-circle-check' : ''" -->
    <el-button
      slot="reference"
      :disabled="disabled"
      type="danger"
      icon="el-icon-circle-check"
      class="btn"
      size="mini"
    >剔除</el-button>
  </el-popover>
  <el-button
    :disabled="disabled"
    class="btn"
    size="mini"
    @click="handleClearOperator"
  >清除标记</el-button>
</section>
</template>

<script>
import manualOperatorTypes from './manualOperatorTypes'

export default {
  name: 'AuditOperatorBtnGroup',
  props: {
    model: Object,
    disabled: Boolean
  },
  data () {
    return {
      showReserveTextArea: false,
      showDeleteTextArea: false,
      popVisible: Object.fromEntries(manualOperatorTypes.map(manualOperatorType => [manualOperatorType.id, false])),
      modelComments: Object.fromEntries(manualOperatorTypes.map(manualOperatorType => [manualOperatorType.id, ''])),
      errorMsg: Object.fromEntries(manualOperatorTypes.map(manualOperatorType => [manualOperatorType.id, '']))
    }
  },
  computed: {
    manualOperatorTypes: () => manualOperatorTypes,
    manualOperatorTypeMap () {
      return manualOperatorTypes.reduce((map, manualOperatorType) => {
        map[manualOperatorType.id] = manualOperatorType
        return map
      }, {})
    },
    reserveComments: () => [{
      id: '其它',
      showTextArea: true
    }],
    deleteComments: () => [{
      id: '未知物质干扰'
    }, {
      id: '峰窗漂移'
    }, {
      id: '仪器异常'
    }, {
      id: '数采异常'
    }, {
      id: '通标残留'
    }, {
      id: '高峰异常'
    }, {
      id: '外界环境影响'
    }, {
      id: '校准维护'
    }, {
      id: '基线异常'
    }, {
      id: '积分异常'
    }, {
      id: '其它',
      showTextArea: true
    }]
  },
  methods: {
    clear () {
      let {model, modelComments} = this
      model.operatorType = model.comment = ''

      for (let key in modelComments) {
        modelComments[key] = ''
      }

      this.showReserveTextArea = false
      this.showDeleteTextArea = false
    },
    emitChange () {
      this.$emit('change')
    },
    handleSetComment (commentItem, operatorType, showTextAreaProp) {
      let model = this.model

      if (commentItem.showTextArea) {
        this[showTextAreaProp] = true
      } else {
        model.operatorType = operatorType
        model.comment = commentItem.id
        this[showTextAreaProp] = false
        this.popVisible[operatorType] = false
        this.emitChange()
      }
    },
    handleSetCustomComment (operatorType) {
      let model = this.model
      let comment = this.modelComments[operatorType]

      if (comment === '') {
        this.errorMsg[operatorType] = '请输入原因'
        return
      } else {
        this.errorMsg[operatorType] = ''
      }

      model.operatorType = operatorType
      model.comment = comment
      this.popVisible[operatorType] = false
      this.emitChange()
    },
    handlePopHide (operatorType, showTextProp, commentsProp) {
      let comment = this.model.comment

      if (this[showTextProp] && this[commentsProp].findIndex(commentItem => commentItem.id === comment) > -1) {
        this[showTextProp] = false
      }
    },
    handleClearOperator () {
      let model = this.model
      model.operatorType = model.comment = null
      this.emitChange()
    }
  }
}
</script>

<style lang="scss" scoped>
.comment-wrapper {
  position: relative;
  width: 320px;
  margin: 0;
  padding: 0;

  &.comment-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 12px;
    grid-row-gap: .5em;

    > .comment-wrapper {
      grid-column: 1 / 4;
    }
  }

  .comment-item {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: .3em 0;
    background-color: #f5f5f5;
    text-align: center;
    cursor: pointer;

    &.active,
    &:hover {
      background-color: #409EFF;
      color: #FFFFFF;
    }
  }

  .comment-btn {
    position: absolute;
    right: 5px;
    bottom: 5px;
  }
}

.error-msg {
  color: red;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditOperatorBtnGroup.vue